import { AppProvider } from './context/AppContext';
import { CartProvider } from './context/CartContext';  // also missing import
import { useApp } from './context/AppContext';

import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import './styles/global.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/pages.css';

function AppContent() {
  const { page } = useApp();

  return (
    <>
      <Header />
      <main>
        {page === 'home' && <HomePage />}
        {page === 'products' && <ProductsPage />}
        {page === 'product-detail' && <ProductDetailPage />}
        {page === 'cart' && <CartPage />}
        {page === 'checkout' && <CheckoutPage />}
        {page === 'order-confirmation' && <OrderConfirmationPage />}
        {page === 'about' && <AboutPage />}
        {page === 'contact' && <ContactPage />}
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <CartProvider>
        <AppContent />
      </CartProvider>
    </AppProvider>
  );
}

export default App;